import React, { useEffect, useRef, useState } from 'react'
import { createEditor, Descendant, Editor } from 'slate'
import { Slate, withReact } from 'slate-react'
import { FileTextIcon } from 'src/icons'
import { withReadOnlyBadge } from 'src/utils/slate'

import { CustomDescendant, SlateEditor, SlateEditorAddedProps } from '../../types/slateTypes'
import { CustomEditable } from '../../utils/slateComponents'
import Typography from '../Typography'
import { HeaderContainer, TitleWrapper, WrapperContainer } from './styles'

export type TerminologyTextAreaRefType = SlateEditor
export interface TerminologyTextAreaProps {
  initialValue?: [CustomDescendant, ...CustomDescendant[]]
  title?: string
  placeholder?: string
  slateOptions?: SlateEditorAddedProps
  onChange?: (value: CustomDescendant[]) => void
}

const TerminologyTextArea = React.forwardRef<TerminologyTextAreaRefType, TerminologyTextAreaProps>(
  ({ title, placeholder, initialValue, onChange, slateOptions }: TerminologyTextAreaProps, ref) => {
    const [editor] = useState(withReadOnlyBadge(withReact(createEditor()) as SlateEditor, slateOptions))

    // expose all custom editor methods via ref
    React.useImperativeHandle(ref, () => editor)

    // normalize initial value on first render
    const isInitialValueNormalized = useRef(false)
    useEffect(() => {
      if (!isInitialValueNormalized.current) {
        isInitialValueNormalized.current = true
        Editor.normalize(editor, { force: true })
      }
    }, [editor.children])

    return (
      <WrapperContainer id="nova-shared-Terminology-Text-Area-root" isEmpty={editor.isBlank()}>
        <HeaderContainer>
          {title && (
            <TitleWrapper>
              <FileTextIcon style={{ fontSize: '21px' }} />
              <Typography variant="s" bold>
                {title}
              </Typography>
            </TitleWrapper>
          )}
        </HeaderContainer>
        <Slate
          editor={editor}
          initialValue={initialValue ?? ([{ type: 'paragraph', children: [{ text: '' }] }] as unknown as Descendant[])}
          onValueChange={onChange}
        >
          <CustomEditable
            editor={editor}
            className="slateEditor"
            placeholder={editor.isBlank() ? placeholder : undefined}
            listItemLineHeight={slateOptions?.listItemLineHeight}
          />
        </Slate>
      </WrapperContainer>
    )
  },
)
TerminologyTextArea.displayName = 'TerminologyTextArea'
export default TerminologyTextArea
